import { useEffect, useState } from 'react';
import { loadMercadoPago } from '@mercadopago/sdk-js';
import licenseService from '../services/licenseService';

let sdkInitPromise = null;

async function initMercadoPagoSdk(publicKey) {
  if (!publicKey) {
    throw new Error('Chave pública do Mercado Pago não configurada');
  }

  if (sdkInitPromise) {
    return sdkInitPromise;
  }

  sdkInitPromise = (async () => {
    await loadMercadoPago();
    if (!window.MercadoPago) {
      throw new Error('SDK do Mercado Pago indisponível');
    }
    return new window.MercadoPago(publicKey, { locale: 'pt-BR' });
  })();

  try {
    return await sdkInitPromise;
  } catch (error) {
    sdkInitPromise = null;
    throw error;
  }
}

export function useMercadoPagoSdk() {
  const [sdk, setSdk] = useState(null);
  const [publicKey, setPublicKey] = useState(null);
  const [sandboxCheckout, setSandboxCheckout] = useState(false);
  const [embeddedCardCheckout, setEmbeddedCardCheckout] = useState(false);
  const [testPayerEmail, setTestPayerEmail] = useState('');
  const [checkoutHints, setCheckoutHints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const bootstrap = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await licenseService.getMercadoPagoPublicKey();
        if (!response.success) {
          throw new Error(response.error || 'Erro ao obter chave pública');
        }

        const key = response.data?.publicKey;
        if (mounted) {
          setSandboxCheckout(Boolean(response.data?.sandboxCheckout));
          setEmbeddedCardCheckout(Boolean(response.data?.embeddedCardCheckout));
          setTestPayerEmail(response.data?.testPayerEmail || '');
          setCheckoutHints(Array.isArray(response.data?.checkoutHints)
            ? response.data.checkoutHints
            : []);
        }

        if (key) {
          const instance = await initMercadoPagoSdk(key);
          if (!mounted) return;
          setPublicKey(key);
          setSdk(instance);
        }
        setLoading(false);
      } catch (err) {
        if (!mounted) return;
        console.error('[Mercado Pago SDK]', err);
        setError(err);
        setLoading(false);
      }
    };

    bootstrap();

    return () => {
      mounted = false;
    };
  }, []);

  return {
    sdk,
    publicKey,
    sandboxCheckout,
    embeddedCardCheckout,
    testPayerEmail,
    checkoutHints,
    loading,
    error,
    ready: Boolean(sdk && publicKey),
  };
}
